/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type TradeDesignManagerPdpLauncher_user$ref = any;
type TradeOnboardingCoachmarkConditionalLoader_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespIconBubbleDesignManager_user$ref: FragmentReference;
export type PdpRespIconBubbleDesignManager_user = {|
  +tradeFirmDesignManagerProfile: ?{|
    +hasAccount: ?any,
    +accountType: ?string,
  |},
  +$fragmentRefs: TradeOnboardingCoachmarkConditionalLoader_user$ref & TradeDesignManagerPdpLauncher_user$ref,
  +$refType: PdpRespIconBubbleDesignManager_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespIconBubbleDesignManager_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "tradeFirmDesignManagerProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmDesignManagerProfileType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasAccount",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "accountType",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "TradeOnboardingCoachmarkConditionalLoader_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TradeDesignManagerPdpLauncher_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6f89da57769f1e767cdea66d3d47b57b';
module.exports = node;
